import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { importantSectionItems } from '../config/contentItems';
const ImportantSectionContent: FC = () => <ImportantSectionContentWrapper>
    {importantSectionItems.map((item, index) => <ImportantSectionItemWrapper key={index}>
        <IconWrapper>{item.icon}</IconWrapper>
        <ContentWrapper>{item.content}</ContentWrapper>
      </ImportantSectionItemWrapper>)}
  </ImportantSectionContentWrapper>;
export default ImportantSectionContent;
const ImportantSectionContentWrapper = /*#__PURE__*/styled('div')({
  name: "ImportantSectionContentWrapper",
  class: "i12sey2g",
  propsAsIs: false
});
const ImportantSectionItemWrapper = /*#__PURE__*/styled('div')({
  name: "ImportantSectionItemWrapper",
  class: "i11xg03s",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.secondary;
const IconWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "idquyqh",
  propsAsIs: false,
  vars: {
    "idquyqh-0": [_exp()]
  }
}));
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1yr2eyk",
  propsAsIs: false
});

require("./ImportantSectionContent.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ImportantSectionContent.tsx");